import { Router } from '@lightningjs/sdk'
import { BASE_ROUTES } from '../../constants/routes'
import { TvCarouselContainerModel } from '../../types/flo-experience'
import TvEventCard from '../TvCards/TvEventCard'
import TvCarouselContainer from '../TvCarouselContainer/TvCarouselContainer'
import TvRowsContainer from '../TvRowsContainer/TvRowsContainer'

export default class UpNextCarousel extends TvRowsContainer {
  private _playlist: TvCarouselContainerModel
  private _isLive: boolean

  set title(v: string) {
    if (this.carouselsContainer.children?.[0] as TvCarouselContainer)
      // Cast to any because the setter / getter of the TVCarouselContainer have different types
      (this.carouselsContainer.children[0] as TvCarouselContainer as any).title = v
  }

  set playlist(v) {
    this._playlist = v
  }

  set isLive(v) {
    this._isLive = v
  }

  _handleUp() {
    return false
  }

  _handleEnter() {
    return false
  }

  _captureEnter() {
    if (this._isLive) {
      const data = (
        (this.carouselsContainer.children[0] as TvCarouselContainer).currentCard as TvEventCard
      ).data
      Router.navigate(`${BASE_ROUTES.PLAYER}/${data.id}`, {
        ...data.action,
        subtitle: data?.details?.text ?? data?.action?.content_metadata?.stream_name,
        imgUrl: data?.preview_image?.url,
        playlist: this._playlist,
      })
    } else {
      this.fireAncestors('$playlistItemSelected')
      return false
    }
  }
}
